import { mdiGoogleDrive, mdiMicrosoftSharepoint } from '@lumapps/lumx/icons';
import { UserAccountType } from '@lumapps/user/types';

import { MEDIAS } from './keys';
import { UrlPatterns } from './types';

/**
 * Used to match the protocol and sub-domain.
 *
 * @type {Regex}
 */
export const PROTOCOL_REGEX = /^(https?:)?\/\/(www\.)?/;

/**
 * Used to match a lumdrive file URL.
 *
 * @type {string}
 */
export const LUMDRIVE_URL_REGEX_STR = '(https?://[^/]+)?(/serve/.*?)';

/**
 * Used to match a haussmann file URL.
 *
 * @type {string}
 */
export const HAUSSMANN_URL_REGEX_STR =
    '(https?://[^/]+)?(/_ah/api/lumsites/v2/organizations/[0-9]+/)(medias|documents)(/[a-zA-Z0-9-=]+/permalink)([^/]+)?';

/**
 * Contains some common URL pattern for the video website we handle.
 *
 * @type {Object}
 */
export const URL_PATTERNS: UrlPatterns = {
    dailymotion: ['dailymotion.com/video/', 'dai.ly/', 'dailymotion.com/embed/video/'],
    vimeo: ['vimeo.com/', 'player.vimeo.com/video/'],
    youtube: [
        'youtube.com/watch?v=',
        'youtu.be/',
        'youtube.com/embed/',
        'youtube.com/live/',
        'youtube.googleapis.com/v/',
        'youtube.com/',
    ],
};

/** Classname for File preview block components */
export const FILE_PREVIEW_BLOCK_CLASSNAME = 'file-preview-block';

export const DRIVE_ITEM_INFOS = {
    [UserAccountType.GOOGLE]: {
        icon: mdiGoogleDrive,
        key: MEDIAS.FROM_GOOGLE_DRIVE,
    },
    [UserAccountType.MICROSOFT]: {
        icon: mdiMicrosoftSharepoint,
        key: MEDIAS.FROM_MICROSOFT_SHAREPOINT,
    },
} as const;

/** All the video file mimetype */
export const VIDEO_MIME_TYPES = [
    'application/vnd.google-apps.vid',
    'application/vnd.google-apps.video',
    'video/mpeg',
    'video/mp4',
    'video/x-msvideo',
    'video/x-quicktime',
    'video/x-ms-wmv',
    'video/quicktime',
    'video/avi',
    'video/x-matroska',
];
